import { animate as animate14 } from 'vendor';

class CartBar extends HTMLElement {
	constructor() {
		super();
		this.barSteps = this.querySelectorAll('.bar-step');
		this.barText = this.querySelector('.cart-bar__text');
		this.barProgress = this.querySelector('.cart-bar__progress-inner');
	}
	async connectedCallback() {
		this.initBarStepPositions();
		await this.renderText();
		await this.renderActive();
	}
	initBarStepPositions() {
		this.syncDisplayMode();
		const rulePositions = window.themeConnector.getRulePositions();
		this.barSteps.forEach((step) => {
			const ruleID = step.dataset.ruleId;
			const rule = rulePositions.find((rule) => rule.ruleID === ruleID);
			step.style.setProperty('display', rule ? 'block' : 'none', 'important');
			step.style.left = `${(rule?.position || 0) * 100}%`;
		});
		if (this.classList.contains('cart-bar--milestones')) {
			this.renderMilestoneConnectors(rulePositions);
		}
	}
	syncDisplayMode() {
		const milestones = window.themeConnector.cartRuleEngine.displayMode === 'milestones';
		this.classList.toggle('cart-bar--milestones', milestones);
		this.classList.toggle('cart-bar--progress_bar', !milestones);
		if (!milestones) {
			this.querySelectorAll('.milestone-connector').forEach((connector) => connector.remove());
		}
	}
	renderMilestoneConnectors(rulePositions) {
		const track = this.querySelector('.cart-bar__progress');
		track.querySelectorAll('.milestone-connector').forEach((connector) => connector.remove());
		const positions = rulePositions
			.filter((rule) => [...this.barSteps].some((step) => step.dataset.ruleId === rule.ruleID))
			.map((rule) => rule.position)
			.sort((a, b) => a - b);
		this.style.setProperty('--milestone-count', positions.length);
		positions.slice(1).forEach((position, index) => {
			const connector = document.createElement('div');
			connector.className = 'milestone-connector';
			connector.style.setProperty('--connector-left', `${positions[index] * 100}%`);
			connector.style.setProperty('--connector-right', `${position * 100}%`);
			track.appendChild(connector);
		});
	}
	async renderText() {
		const formattedText = await window.themeConnector.getFormattedText();
		this.barText.innerHTML = formattedText;
	}
	async renderActive() {
		const qualifiedRules = await window.themeConnector.getQualifiedRules();
		this.barSteps.forEach((step) => {
			const ruleID = step.dataset.ruleId;
			const qualifiedRule = qualifiedRules.find((rule) => rule.ruleID === ruleID);
			step.classList.toggle('active', !!qualifiedRule);
		});
	}
	animateProgressBar(oldProgress, newProgress) {
		animate14(
			this.barProgress,
			{ width: [`${oldProgress}%`, `${newProgress}%`] },
			{ duration: 0.3, delay: 0, easing: [0.25, 0.46, 0.45, 0.94] },
		);
	}
	setProgressWidth(progress) {
		this.barProgress.style.width = `${progress}%`;
	}
}

if (!window.customElements.get('cart-bar')) {
	window.customElements.define('cart-bar', CartBar);
}
